import { styled } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { GRADIENTS } from '@components/web/src/styles';

export const DiscountBannerWrapper = styled(Flexbox)`
  height: 40px;
  padding: 0 20px;
  background: ${GRADIENTS.primaryGradient};
`;
